module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dane ogólne")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors['name']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.producer.name),
      callback: function($$v) {
        _vm.producer.name = $$v
      },
      expression: "producer.name"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Link",
      "error": _vm.errors['link']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.producer.link),
      callback: function($$v) {
        _vm.producer.link = $$v
      },
      expression: "producer.link"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors['description']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "5"
    },
    model: {
      value: (_vm.producer.description),
      callback: function($$v) {
        _vm.producer.description = $$v
      },
      expression: "producer.description"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Godziny otwarcia",
      "error": _vm.errors['openingHours']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "5"
    },
    model: {
      value: (_vm.producer.openingHours),
      callback: function($$v) {
        _vm.producer.openingHours = $$v
      },
      expression: "producer.openingHours"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Produkty producenta")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Produkty",
      "error": _vm.errors['products']
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.productsOptions
    },
    model: {
      value: (_vm.producer.products),
      callback: function($$v) {
        _vm.producer.products = $$v
      },
      expression: "producer.products"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Logo")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Logo",
      "error": _vm.errors['logo']
    }
  }, [_c('media-input', {
    model: {
      value: (_vm.producer.logo),
      callback: function($$v) {
        _vm.producer.logo = $$v
      },
      expression: "producer.logo"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-160aca3a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProducerAddEdit.vue
// module id = 428
// module chunks = 1